import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
    globalStore
} from '../helpers';

export const importService = {
    importClients,
    importProjects,
    importProjectCategories,
    importExpenseCategories,
    importExpenses,
    importTimeEntries

};

function importClients(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`clients/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}

function importProjects(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`projects/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}

function importProjectCategories(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`projectCategories/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}

function importExpenseCategories(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`expenses/categories/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}

function importExpenses(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`expenses/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}

function importTimeEntries(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.post(`timeentries/import/${companyId}`, requestOptions).then(handleResult).catch(handleException);
}